import { Avatar } from '#app/components/Avatars/Avatar/Avatar.js';
import { css, styled } from 'styled-components';

export const StyledAvatar = styled(Avatar)<{
  $showBorder: boolean;
}>`
  ${({ $showBorder, theme }) => css`
    ${$showBorder
      ? css`
          border: 1px solid ${theme.colorsV2.gray30};
        `
      : undefined}

    border-radius: 50%;
  `}
`;

export const StyledEditableAvatarBox = styled.div`
  position: absolute;

  z-index: 6;
`;

export const StyledAvatarEditorBox = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: white;

  position: absolute;
  bottom: 0;
  right: 0;
`;

export const AvatarHoverBox = styled.div`
  position: relative;
  z-index: 6;
`;
